import styled from 'styled-components';

export const Title = styled.h3`
  display: flex;
  gap: 12px;
  overflow: hidden;
  color: ${({ theme }) => theme.colors.black9};
  text-overflow: ellipsis;
  font-family: ${({ theme }) => theme.fontFamily.primary};
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: -0.2px;
`;

export const MaxHeightUl = styled.ul`
  max-height: 150px;
  overflow-y: auto;
  padding-left: 16px;
`;

export const ActivityItem = styled.li`
  cursor: pointer;
  text-decoration: underline;

  font-family: ${({ theme }) => theme.fontFamily.primary};
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  text-decoration-line: underline;
  text-decoration-style: solid;
  text-decoration-skip-ink: auto;
  text-decoration-thickness: auto;
  text-underline-offset: auto;
`;
